import { useState } from "react";
import { Popconfirm, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import Button from "components/buttons/Button";
import Fetch from "components/Fetch";
import colors from "constants/palette";

export default function DeleteButton({ id, reload, title, link, style = {} }) {
  const [visible, setVisible] = useState(false);

  const [loading, setLoading] = useState(false);
  const showPopconfirm = () => {
    setVisible(true);
  };
  const handleDelete = () => {
    setLoading(true);
    Fetch.delete(`/${link}/${id}`, (res) => {
      console.log("delete button response ----------------------", res);
      if (res === 1) {
        message.success("با موفقیت حذف شد");
      } else {
        message.error("خطایی رخ داده است");
      }
      setLoading(false);
      setVisible(false);

      reload && reload(true);
    });
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setVisible(false);
  };
  return (
    <Popconfirm
      title={`آیا از حذف این ${title} اطمینان دارید؟`}
      onConfirm={handleDelete}
      visible={visible}
      onCancel={handleCancel}
      okButtonProps={{ loading: loading }}
      cancelText="لغو"
      okText="تایید"
    >
      <Button
        color={colors.red}
        style={{ marginRight: 6, ...style }}
        onClick={showPopconfirm}
      >
        <DeleteOutlined />
      </Button>
    </Popconfirm>
  );
}
